import React, { AllHTMLAttributes, FC, PropsWithChildren } from 'react';

import { cn } from '../../../../utils';

import './ProjectFavorite.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const ProjectFavorite: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return (
    <div {...props} className={cn('project-favorite', props.className)}>
      {children}
    </div>
  );
};

export default ProjectFavorite;
